import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

function ResponsiveButton({ icon, label, ...props }) {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('md'));

  return isXs ? (

    <IconButton {...props}>
      {icon}
    </IconButton>
  ) : (
    <Button {...props} startIcon={icon}>
      {label}
    </Button>
  );
}

ResponsiveButton.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
};

export default ResponsiveButton;
